import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowPickersItemStyle } from './datecalendar.theme';

// day button in DateCalendar
export const flowPickersDay: Components<Theme>['MuiPickersDay'] = {
  styleOverrides: {
    // style is reused in month, year, and digital clocks themes
    root: ({ theme }) => ({
      ...flowPickersItemStyle(theme),
      position: 'relative',
      // update proportions to match figma
      margin: '3px',
      width: '40px',
      height: '40px',
    }),
    // highlighted today
    today: ({ theme }) => ({
      '&:not(.Mui-selected)': {
        '&, &:hover, &:focus': {
          borderColor: theme.palette.text.primary,
        },
      },
    }),
  },
};
